import React from 'react';
import { MdHighQuality, MdSecurity } from "react-icons/md";
import { BsFillFileCodeFill } from "react-icons/bs";
import { BiSupport } from "react-icons/bi";
import { Link } from 'react-router-dom';

const AboutMeSome = () => {
    return (
        <div className='bg-[#F4F7FD] h-full'>
            <div className="container mx-auto xl:px-40 px-2 md:py-10 py-5">
                <div className="text-center md:p-10 p-3 bg-white rounded-xl shadow-md">
                    <div className="pb-5">
                        <h2 className="text-3xl font-poppins font-semibold text-gray-700">Hi.</h2>
                        <h2 className="text-4xl font-poppins font-extrabold text-gray-700"><span className='text-purple-600'>I'm </span> Munir Uddin Mahbub</h2>
                        <h4 className="text-xl font-inter font-bold text-gray-700">Professional Full-Stack Web Developer</h4>
                        <hr className="h-0.5 bg-primary text-primary" />
                        <p className="text-md font-poppins font-medium py-2 text-gray-600 ">
                            I'm a reliable goal-driven person and I want everything to be in order. I am responsible and initiative team-member, result-oriented. I have the ability to solve complex problems. My target is the client's full satisfaction and doing the best to deliver the most efficient and highest quality projects.
                        </p>
                    </div>
                    <div className="grid grid-cols-4 text-start gap-5">
                        <div className="md:col-span-2 col-span-4 border-2 border-primary p-4 rounded-l-2xl rounded-t-xl">
                            <div className="flex gap-4">
                                <span className='grid content-center p-1 rounded-full border-2 border-primary'><MdHighQuality className='text-xl text-primary' /></span>
                                <h2 className='text-xl font-poppins font-bold text-primary'> Quality</h2>
                            </div>
                            <p className='font-poppins font-medium p-2 text-gray-600'>
                                Design Quality is very important for every website, I make sure 100% quality & satisfaction before delivering the project.
                            </p>
                        </div>
                        <div className="md:col-span-2 col-span-4 border-2 border-primary p-4 rounded-r-2xl rounded-t-xl">
                            <div className="flex gap-4">
                                <span className='grid content-center p-1 rounded-full border-2 border-primary'><BsFillFileCodeFill className='text-xl text-primary' /></span>
                                <h2 className='text-xl font-poppins font-bold text-primary'> Integrity</h2>
                            </div>
                            <p className='font-poppins font-medium p-2 text-gray-600'>
                                Friendly coding and design professionality increase website speed and SEO result, only experienced person can make sure this.
                            </p>
                        </div>
                        <div className="md:col-span-2 col-span-4 border-2 border-primary p-4 rounded-l-2xl rounded-b-2xl">
                            <div className="flex gap-4">
                                <span className='grid content-center p-1 rounded-full border-2 border-primary'><MdSecurity className='text-xl text-primary' /></span>
                                <h2 className='text-xl font-poppins font-bold text-primary'> Security & Safety</h2>
                            </div>
                            <p className='font-poppins font-medium p-2 text-gray-600'>
                                Get complete security website and safe your all data and information.
                            </p>
                        </div>
                        <div className="md:col-span-2 col-span-4 border-2 border-primary p-4 rounded-r-2xl rounded-b-2xl">
                            <div className="flex gap-4">
                                <span className='grid content-center p-1 rounded-full border-2 border-primary'><BiSupport className='text-xl text-primary' /></span>
                                <h2 className='text-xl font-poppins font-bold text-primary'> Support</h2>
                            </div>

                            <p className='font-poppins font-medium p-2 text-gray-600'>
                                Get life time working relationship & support with full instructions.
                            </p>
                        </div>
                    </div>
                    <Link to="/contact">
                        <button className="py-2 bg-primary w-full mt-5 text-white rounded-xl uppercase font-poppins font-semibold">Contact Me</button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AboutMeSome;